import { Inject, Injectable } from '@angular/core';
import { DevwareMetaData, DwAppPermissionEntity, DwAppPermissionMetaData, DwAttributeType, DwCacheService, DwContextDefinition, DwControlType, DwCustomContextBase, DwCustomContextDefinition, DwMdFormContextInfo, DwMenuService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwQueryBuilderGen, DwQueryHelper, DwQueryMdAttribute, DwRoutingService, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, CourseEntity, CourseModuleEntity, RoModuleLessonMaxOrderEntity, StudentCourseForContextQueryBuilder, StudentCourseForContextQueryEntity, StudentCourseForContextQueryMetaDataAttributes } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CourseRepositoryService } from '../services/course-repository.service';


export const StudentModuleProgressContext = 'studentModuleProgressContext';

@DwCustomContextDefinition({
    keyName: StudentModuleProgressContext,
    display: 'Student Module Progress Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.CourseModule
})
@Injectable()
export class StudentModuleProgressContextService extends DwCustomContextBase {
    query: DwQuery;
    
    constructor(private dwSecurityUserService: DwSecurityUserService,
        private dwRoutingService: DwRoutingService,
        private dwMenuService: DwMenuService,
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private dwCacheService: DwCacheService
    ) {
        super();
    }
   
    count = -1;
    setupContextDefinition(contextDef: DwContextDefinition) :Observable<void> {
        contextDef.buildQueryFunction = (context) => this.buildQuery(context);

        contextDef.item = AppMetaDataItemNames.CourseModuleProgress;
        //contextDef.parentItem = AppMetaDataItemNames.Course;

        contextDef.getCustomContextKey = (context) => {
            const module: CourseModuleEntity = context[DwMdFormContextInfo.DATA_CONTEXT_NAME];

            if (!module) {
                console.warn('No module found in context for StudentModuleProgressContext');
                this.count--;
                return this.count;
            }

            return module?.CourseModuleId;
        };

        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];

        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.CourseModuleProgress.ItemDetail.itemName));
        contextDef.cacheInvalidationTopics.push(CourseRepositoryService.COURSE_PROGRESS_UPDATE_EVENT);

        return AppMetaData.Queries.CourseModuleProgressWithAISummary.CreateQueryBuilderWithMetaData(this.dwMetaDataService)
            .pipe(map(result => {
                this.query = result.queryBuilder.query;
                
                contextDef.attributes = result.queryMetaData.Attributes;
            }));
    }

    buildQuery(resolvedContext: any): DwQuery {
        const module: CourseModuleEntity = resolvedContext[DwMdFormContextInfo.DATA_CONTEXT_NAME];

        if (!module) {
            return null;
        }
        const qh = new DwQueryHelper();

        const query = AppMetaData.Queries.CourseModuleProgressWithAISummary.CreateQueryBuilderFromQuery(qh.cloneQuery(this.query));
        
        if (!this.dwSecurityUserService.securityContext?.ApplicationUser) {
            return null;
        }
   
        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        
        const user = this.dwSecurityUserService.securityContext.ApplicationUser;
        
        query.addFilterAnd(filters => filters.Equal(f => f.StudentUserId, user?.UserId || -1));
        query.addFilterAnd(filters => filters.Equal(f => f.CourseModuleId, module.CourseModuleId));

        return query.query;
    }
}
